import React, { useEffect, useRef } from 'react';

const ChatMessageAudioPlayer = ({ src }) => {
    const audioRef = useRef(null);

    useEffect(() => {
        // اطمینان از وجود ref و آدرس فایل
        if (audioRef.current && src) {
            // تنظیم آدرس و فراخوانی load برای سازگاری با iOS
            audioRef.current.src = src;
            audioRef.current.load();
        }
    }, [src]); // این افکت با تغییر آدرس فایل اجرا می‌شود

    return (
        <audio ref={audioRef} controls style={{ width: '100%' }} controlsList="nodownload">
            مرورگر شما از پخش صدا پشتیبانی نمی‌کند.
        </audio>
    );
};

export default ChatMessageAudioPlayer;
